<template>
  <c-card v-if="widgetHtml" class="overflow-hidden">
    <!-- eslint-disable vue/no-v-html -->
    <div
      ref="banner"
      class="sidebar-banner-content text-center"
      v-html="widgetHtml"
    />
    <!-- eslint-enable -->
  </c-card>
</template>

<script>
  import { CCard } from '@clickadilla/components/components'

  export default {
    name: 'WidgetBanner',
    components: {
      CCard
    },
    props: {
      widgetHtml: {
        type: String,
        default: ''
      }
    },
    watch: {
      async widgetHtml() {
        await this.$nextTick()
        if (this.$refs.banner) {
          this.$refs.banner.removeEventListener('click', this.bannerClickHandler)
          this.$refs.banner.addEventListener('click', this.bannerClickHandler)
        }
      }
    },
    beforeUnmount() {
      if (this.$refs.banner) {
        this.$refs.banner.removeEventListener('click', this.bannerClickHandler)
      }
    },
    methods: {
      bannerClickHandler(event) {
        if (event.target.classList.contains('open-intercom')) {
          this.$intercom.show()
        }
      }
    }
  }
</script>

<style lang="scss">
.sidebar-banner-content {
  position: relative;

  * {
    max-width: 100%;
    min-width: 100%;
    display: flex;
  }
}
</style>
